import { JobType } from '../../constants';
import { createTableSlice } from '../helpers';

export const tableSlice = createTableSlice({
  name: 'automatedJobs/dicomConversionTable',
  url: '/api/jobs',
  filters: {
    type: JobType.DICOM_CONVERSION,
  },
  sortOrder: 'desc',
  orderBy: 'id',
});
